var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictoSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128 128",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.2,16.9c-21.2,0-38.3,17.1-38.3,38.3s17.1,38.3,38.3,38.3c10.4,0,19.9-4.2,26.8-10.9l0.3-0.3 c0.1-0.1,0.2-0.2,0.3-0.3c6.8-6.9,10.9-16.4,10.9-26.8C93.5,34,76.4,16.9,55.2,16.9z M55.2,5.1c27.7,0,50.1,22.4,50.1,50.1 c0,11.7-4,22.5-10.7,31l26.7,26.7c2.3,2.3,2.3,6,0,8.3c-2.3,2.3-6,2.3-8.3,0L86.2,94.5c-8.5,6.7-19.3,10.7-31,10.7 c-27.7,0-50.1-22.4-50.1-50.1S27.6,5.1,55.2,5.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoSearch);
export default __webpack_public_path__ + "static/media/picto-search.e54103bc.svg";
export { ForwardRef as ReactComponent };